import { render, staticRenderFns } from "./MunicipioCombo.vue?vue&type=template&id=6f94c154"
import script from "./MunicipioCombo.vue?vue&type=script&lang=js"
export * from "./MunicipioCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports